import React, { useState, useRef } from 'react';
import { Link, withRouter } from 'react-router-dom';
import SVG from 'react-inlinesvg';

// App Custom Source
import OnResize from '../misc/onResize';
import { breakPoints } from "../../lib/consts";

// App Local Assets
import showIcon from '../../assets/chevron-down.svg';
import hideIcon from '../../assets/chevron-up.svg';
import nextIcon from '../../assets/chevron-right.svg';
import menuIcon from '../../assets/menu.svg';
import closeIcon from '../../assets/close.svg';

const GlobalNav = (props = {}) => {
  let currentURL = window.location.pathname;
  const { tLang, routes } = props;
  const t = tLang;
  const [toggleDownloadButton, setToggleDownloadButton] = useState(false);
  const [toggleHamburgerNav, setToggleHamburgerNav] = useState(false);
  const hamburgerRef = useRef(null);
  const toggleHamburgerBTN = useRef(null);
  let windowDimmentions = OnResize();

  const clickDownloadBTN = e => {
    const target = e.target;
    const element = (target.tagName !== 'BUTTON') ? target.parentElement : target;
    const displayContainer = element.dataset.attributeDisplayContainer;
    const visibility = (displayContainer === 'true') ? true : false;

    setToggleDownloadButton(!visibility);
  };

  const clickHamburgerMenu = e => {
    e.preventDefault();

    setToggleHamburgerNav(!toggleHamburgerNav);
    const hamburgerNode = hamburgerRef.current;
    const classList = hamburgerNode.classList;

    if (!!classList.contains('opened')) {
      classList.add('closing');

      setTimeout(() => {

        classList.remove('opened');
        classList.remove('closing');
      }, 500);
    } else {
      classList.add('opened');
    }
  };

  const hamburgerForcedToClose = e => {
    e.preventDefault();

    const isClickeable = e.target.closest(['a, button:not(.hamburger-toggle)']);
    if (toggleHamburgerNav && isClickeable) {
      setTimeout(() => {
        if (!!toggleHamburgerBTN.current) toggleHamburgerBTN.current.click();
      }, 400);
    }
  }

  const resetDownloadButton = () => {
    setToggleDownloadButton(false);
  };

  const resetAfterOptionSelected = () => {
    setTimeout(() => {
      resetDownloadButton();
    }, 10);
  };

  outsideClickAlerter(resetDownloadButton);

  const options = {
    t: t,
    routes: routes,
    currentURL: currentURL,
    hamburgerRef: hamburgerRef,
    toggleHamburgerBTN: toggleHamburgerBTN,
    clickDownloadBTN: clickDownloadBTN,
    clickHamburgerMenu: clickHamburgerMenu,
    hamburgerForcedToClose: hamburgerForcedToClose,
    resetAfterOptionSelected: resetAfterOptionSelected,
    toggleDownloadButton: toggleDownloadButton,
    toggleHamburgerNav: toggleHamburgerNav
  };

  return (
    navbarContentJSX(windowDimmentions, options)
  );
};

const navbarContentJSX = ({ width }, opts) => {
  const {t, routes} = opts;
  const desktopJSX = (
    <header className="header-nav row sticky">
      <span className="col-lg-1"></span>
      <span className="col-md">
        <Link to={routes.home} className="logo">{t('navbarHome')}</Link>
      </span>
      <Link
        to={routes.posts.list}
        className={`button col-sm col-md ${opts.currentURL.includes(routes.posts.list) ? 'current' : ''}`}>
        {t('navbarPosts')}
      </Link>
      <Link
        to={routes.news.list}
        className={`button col-sm col-md ${opts.currentURL.includes(routes.news.list) ? 'current' : ''}`}>
        {t('navbarNews')}
      </Link>
      <Link
        to={routes.tutorials.list}
        className={`button col-sm col-md ${opts.currentURL.includes(routes.tutorials.list) ? 'current' : ''}`}>
        {t('navbarTutorials')}
      </Link>
      <Link
        to={routes.videos}
        className={`button col-sm col-md ${opts.currentURL.includes(routes.videos) ? 'current' : ''}`}>
        {t('navbarVideos')}
      </Link>
      <button
        className="collapse-button button col-sm col-md"
        data-attribute-display-container={opts.toggleDownloadButton}
        onClick={opts.clickDownloadBTN}>
        {t('navbarDownloads')}
        <SVG
          className="show-hide-chevron"
          src={opts.toggleDownloadButton ? hideIcon : showIcon}
          alt={`${opts.toggleDownloadButton ? 'hide' : 'show'}-icon`}
        /> 
        
        <div className={`collapse-container ${opts.toggleDownloadButton ? 'active-collapse' : ''}`}>
          <ul>
            <li onClick={opts.resetAfterOptionSelected}>
              <Link to={routes.mods} className="button">
                {t('navbarMods')}
              </Link>
            </li>
            <li onClick={opts.resetAfterOptionSelected}>
              <Link to={routes.software} className="button">
                {t('navbarSoftware')}
              </Link>
            </li>
          </ul>
        </div>
      </button>
      <Link
        to={routes.contactInfo}
        className={`button col-sm col-md ${opts.currentURL.includes(routes.contactInfo) ? 'current' : ''}`}>
        {t('navbarContactInfo')}
      </Link>
      {/* LogedIn -> desktop */}
      <span className="col-lg-1"></span>
    </header>
  );

  const mobileJSX = (
    <header className="header-nav sticky">
      <div className="row mobile-row" onClick={opts.hamburgerForcedToClose}>
        <Link to={routes.home} className="logo button col-sm-2">
          <span className="icon-home"></span>
        </Link>
        <div className="col-sm-8 mid-bar"></div>
        <button ref={opts.toggleHamburgerBTN}
          className="col-sm-2 button logo hamburger-toggle"
          onClick={opts.clickHamburgerMenu}>
          <SVG
            src={!opts.toggleHamburgerNav ? menuIcon : closeIcon}
            alt="menu hambuger icon"
          /> 
        </button>
        <div ref={opts.hamburgerRef} className="hamburger-nav-menu">
          <nav>
            <h3>Menu</h3>
            <div className="hamburger-submenu">
              <Link to={routes.posts.list}>
                {t('navbarPosts')}
              </Link>
              <Link to={routes.news.list}>
                {t('navbarNews')}
              </Link>
              <Link to={routes.tutorials.list}>
                {t('navbarTutorials')}
              </Link>
              <Link to={routes.videos}>
                {t('navbarVideos')}
              </Link>
              <span className="category-section">
                {t('navbarDownloads')}
              </span>
              <Link to={routes.mods} className="sub sublink-1">
                <SVG src={nextIcon} />
                {t('navbarMods')}
              </Link>
              <Link to={routes.software} className="sub sublink-1">
                <SVG src={nextIcon} />
                {t('navbarSoftware')}
              </Link>
              {/* <button className="slide-button">
                  // TODO: add a functionality to horizontal collapse
                </button> */}
              <Link to={routes.contactInfo}>
                {t('navbarContactInfo')}
              </Link>
            </div>
            {/* LogedIn -> mobile */}
          </nav>
        </div>
      </div>
    </header>
  );

  return (width < breakPoints.lgBreakPoint) ? mobileJSX : desktopJSX;
};

const outsideClickAlerter = callBack => {
  const ooClick = e => {

    const node = e.target;
    if (node.closest('.collapse-button') && !!!node.closest('.collapse-container')) {

      return false;
    }

    callBack();

    window.removeEventListener('click', ooClick, true);
  }
  window.addEventListener('click', ooClick, true);
}

export default withRouter(GlobalNav);